import React from 'react';
import './HeaderView.css';
import { observer } from 'mobx-react';
import Logo from '../../assets/images/logo_primary.svg';
import { Link } from 'react-router-dom';
import { Container, Input, InputType } from '../../core/components/Index';
// import { MenuBarProfileView } from '../../core/components/Index';
// import { Appl } from '../../core/Appl';

export const HeaderView: React.FC = observer(() => {
  // const userContext = Appl.User;
  return (
    <>
      <header className="w-full z-10 h-[100px]">
        <nav className={`bg-cream-50 h-full border-b-2 border-orange-500  py-1 p-0`}>
          <Container>
            <div className="flex items-center justify-between">
              <Link to="https://my.scers.gov" className={`py-2 flex-shrink-0 md:ml-0`}>
                <img src={Logo} alt="Logo" className='w-[250px] h-[65px] max-h-[90%] flex-shrink-0' />

              </Link>
              <div className="flex items-center space-x-4">
                {/* {userContext.isAuthenticated && (
                  <MenuBarProfileView
                    profileTitle={userContext.displayName}
                    logoutUrl={''}
                    profileUrl={'/myProfile'}
                  />
                )} */}

              </div>
            </div>
          </Container>
        </nav>
      </header>
    </>
  );
});
